{
  "title": "讀懂營運儀表板",
  "description": "了解營運儀表板五組即時 KPI 各自代表的意義，以及報名與資格驗證為何是兩條完全獨立的資料軸。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "畫面說明", "完成後", "常見問題"],
  "summary": "看完後，您能正確解讀每一組 KPI 數字，知道「N/A」代表什麼，並知道哪些數字可以點擊直接前往對應清單頁。",
  "roleNote": "競賽管理員／具營運頁檢視權限的工作人員",
  "prerequisites": ["競賽已建立", "已進入該競賽後台"],
  "pathLabel": "主辦方後台 → 我的競賽 → 營運 → 營運儀表板",
  "steps": [
    {
      "title": "1. 待處理事項",
      "description": "頁面上方會依目前偵測到的資料異常，列出「待處理事項」清單，例如資格驗證待審核、報名未完成、作品未繳交、評審尚未接受邀請等；每一項皆可點擊，直接帶入對應清單頁並套用篩選條件。"
    },
    {
      "title": "2. 五組 KPI",
      "description": "依序為報名、參賽者、資格驗證、作品繳交、評審五組指標卡片。報名顯示隊伍總數、已完成、未完成、已取消；參賽者顯示參賽者總數；資格驗證顯示需驗證人數、已提交、待審核、已通過、已退回、缺件人數，以及提交率與通過率；作品繳交顯示應繳、已提交、草稿、未繳；評審顯示評審總數、已接受、待接受邀請、指派總數、已完成指派、完成率。"
    },
    {
      "title": "3. 報名與資格驗證是兩條獨立的軸",
      "description": "這是本頁最重要的規則：報名完成度與資格驗證狀態完全獨立計算。資格驗證審核中、已退回、已過期或尚未提交，都不會讓一份已完成的報名被重新算成未完成；儀表板與後台其他頁面都不會混算兩者。看到報名「已完成」與資格驗證「待審核」同時出現在同一位參賽者身上，是正常現象，不是資料錯誤。"
    },
    {
      "title": "4. 完成率顯示 N/A",
      "description": "任何完成率類指標（例如資格驗證通過率、評審完成率），只要分母為零，畫面一律顯示「N/A」，不會顯示誤導性的 0% 或 100%。看到 N/A 代表目前尚無可計算的樣本，而不是計算結果剛好為零。"
    },
    {
      "title": "5. 隱藏不需要的 KPI 群組",
      "description": "每個 KPI 群組標題旁有「隱藏」按鈕，可個別收起目前用不到的群組；隱藏後頁面上方會出現「已隱藏：...」摘要列，列出每個被隱藏的群組名稱並提供個別「顯示」按鈕還原。此偏好純屬瀏覽器本機設定，依競賽分別記憶，不會同步到其他裝置或分享給其他管理員；「待處理事項」卡片沒有隱藏選項，恆常可見。"
    }
  ],
  "afterward": [
    "可依「待處理事項」提示，點擊直接前往對應的篩選清單頁處理",
    "可點擊各項 KPI 數字，快速前往報名／參賽者／作品／評審清單頁並帶入對應篩選條件",
    "本頁不取代「總覽」（設定完整度）頁，兩者並存，各自回答不同問題：本頁回答「現在營運狀況如何」，總覽回答「設定是否正確」"
  ],
  "nextSteps": "若「待處理事項」出現資格驗證待審核，可直接點擊前往「隊伍與人員」的資格驗證分頁進行審核。",
  "faq": [
    {
      "q": "為什麼某位參賽者報名已完成，資格驗證卻顯示待審核或已退回？",
      "a": "這是預期行為，不是錯誤。報名完成度只反映報名表單是否填寫完整，資格驗證狀態則是另一條完全獨立的審核流程；兩者互不影響彼此的判定。"
    },
    {
      "q": "完成率顯示 N/A 是不是代表系統出錯？",
      "a": "不是。N/A 代表該項指標目前的分母為零（例如尚無人提交資格驗證資料），因此無法計算比率，畫面刻意不顯示 0% 或 100% 以免誤導。"
    },
    {
      "q": "隱藏某個 KPI 群組後，其他管理員登入會不會也看不到？",
      "a": "不會。隱藏偏好只存在您自己這個瀏覽器的本機儲存，依競賽分別記憶；其他管理員或您自己換一台裝置登入，看到的仍是完整的五組 KPI。"
    }
  ]
}
